"use server"

import { signIn } from "@/lib/auth"
import { prisma } from "@/lib/prisma"
import { AuthError } from "next-auth"

export async function credentialsLogin(
  _prev: { error: string } | null,
  formData: FormData,
): Promise<{ error: string } | null> {
  const email = (formData.get("email") as string)?.trim().toLowerCase()
  const password = formData.get("password") as string

  if (!email || !password) return { error: "Email and password are required." }

  // Determine redirect destination before signIn so role-scoped users land in a valid view.
  const user = await prisma.user.findUnique({
    where: { email },
    select: {
      id: true,
      role: true,
      locations: {
        select: {
          location: {
            select: {
              id: true,
              siteId: true,
              tmsSiteConfig: { select: { siteId: true } },
            },
          },
        },
        take: 1,
      },
    },
  })
  const customerSiteRef = user?.locations[0]?.location.tmsSiteConfig?.siteId
    ?? user?.locations[0]?.location.siteId
    ?? user?.locations[0]?.location.id
  const redirectTo = user?.role === "SUPPORT"
    ? "/support"
    : user?.role === "CUSTOMER" && customerSiteRef
    ? `/tms/${customerSiteRef}/schedule`
    : "/"

  try {
    await signIn("credentials", { email, password, redirectTo })
  } catch (error) {
    if (error instanceof AuthError) {
      return { error: "Invalid email or password." }
    }
    throw error // NEXT_REDIRECT — must re-throw so Next.js handles the redirect
  }
  return null
}
